import { useState, useEffect } from "react";
import WithAuth from "../../components/partials/withAuth";
import { SVGs } from "../../assets/svg/SVGs";
import {
  MssgContainer,
  getEstateID,
  getImage,
  titleCase,
} from "../../components/partials/utils";
import styled from "styled-components";
import {
  HOST_URL,
  SK_VALUE,
  getCookie,
  reqOptions,
} from "../../assets/js/helpFunction";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { downloadData } from "../../utils/downloadData";
import Pagination from "../../components/Pagination";
import "./admin-residents.css";

const ResidentsIcon = ({ name, size = 18 }) => {
  const paths = {
    users: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2m7-10a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm13 10v-2a4 4 0 0 0-3-3.87m-1-11.26a4 4 0 0 1 0 7.75",
    plus: "M12 5v14M5 12h14",
    download: "M12 3v12m0 0 4-4m-4 4-4-4M4 20h16",
    search: "m21 21-4.35-4.35m2.35-5.65a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z",
    check: "m5 12 4 4L19 6",
    pause: "M9 9h.01M15 9h.01M9 15h6",
  };
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d={paths[name]} stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg>;
};

const AdminResidents = () => {
  const [data, setData] = useState({});
  const [residents, setResidents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [downloading, setDownLoading] = useState(false);
  const [mssg, setMssg] = useState({ error: false, mssg: "" });
  const [search, setSearch] = useState("");
  const [activeIndex, setActiveIndex] = useState(1);
  const [openModal, setOpenModal] = useState(false);
  const [actionOpen, setActionOpen] = useState(false);
  const [actionResident, setActionResident] = useState(null);
  const [tabsValues, setTabsValues] = useState(false);
  const [bulkErrorText, setBulkErrorText] = useState(null);
  const [page, setPage] = useState("1");
  const checkActive = (index) => (activeIndex === index ? "active" : "");

  const closeMssg = () => {
    setMssg({ error: false, mssg: "" });
  };

  useEffect(() => {
    setLoading(true);
    const requestOptions = reqOptions("get", null, true);
    const api = `${HOST_URL()}estate_users/admin_list?estate_id=${getEstateID()}&page=${page}&search=${search}`;
    fetch(api, requestOptions)
      .then((res) => res.json())
      .then((data) => {
        setResidents(data.results);
        setData(data);
      })
      .catch((err) => setMssg({ ...mssg, mssg: err.message, error: true }))
      .finally(() => setLoading(false));
  }, [search, page]);

  const filterResident = (index, name) => {
    setActiveIndex(index);
    setTabsValues(name);
    document
      .querySelectorAll("tab")
      .forEach((item) =>
        item.classList.includes(activeIndex)
          ? item.classList.add("active")
          : item.classList.remove("active")
      );

    if (index === 2) {
      setResidents(data.results.filter((item) => item.status === "ACTIVE"));
    } else if (index === 3) {
      setResidents(data.results.filter((item) => item.status !== "ACTIVE"));
    } else {
      setResidents(data.results);
    }
  };

  const addUser = (user) => {
    const api = `${HOST_URL()}estate_users/admin_invite/?estate_id=${getEstateID()}`;
    const requestOptions = reqOptions("post", JSON.stringify(user), true);
    fetch(api, requestOptions)
      .then((res) => res.json())
      .then((data) => {
        if (data.error) {
          setMssg({ ...mssg, mssg: data.error });
        } else {
          setMssg({ ...mssg, mssg: data.message });
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      })
      .catch((err) => setMssg({ ...mssg, mssg: err.message, error: true }));
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleActivate = (resident) => {
    const modifyURL = `${HOST_URL()}estate_users/modify_user/?estate_id=${getEstateID()}`;
    const status = resident.status === "INACTIVE" ? "ACTIVE" : "INACTIVE";
    const requestOptions = reqOptions(
      "post",
      JSON.stringify({ status: status, estate_user_id: resident.id }),
      true
    );
    fetch(modifyURL, requestOptions)
      .then((res) => res.json())
      .then((response) => {
        setResidents(
          residents.map((item) => {
            if (item.id === response.id) {
              return { ...item, status: response.status };
            }
            return item;
          })
        );
        setMssg({
          ...mssg,
          mssg: `Account ${
            status.toLocaleLowerCase() === "active"
              ? "activated"
              : "deactivated"
          } successfully`,
        });
      })
      .catch((err) => setMssg({ ...mssg, mssg: err.message, error: true }));
  };
  const addMultipleUser = (data) => {
    const header = {
      method: "post",
      headers: {
        "EstateIQ-Sk-Header": SK_VALUE(),
        "X-CSRFToken": getCookie("CSRF-TOKEN"),
        Origin: window.location.origin,
        Authorization: "Bearer " + getCookie("access"),
      },
      body: data,
    };

    const bulk_upload_api = `${HOST_URL()}estate_users/estate_user_bulk_upload/?estate_id=${getEstateID()}`;
    fetch(bulk_upload_api, header)
      .then((res) => res.json())
      .then((response) => {
        if (response.error_exist) {
          let error_text = "";
          response.errors.forEach((error) => (error_text += `${error}`));
          setBulkErrorText(error_text);
        } else {
          setMssg({ ...mssg, mssg: response.message });
        }
        setTimeout(() => window.location.reload(), 1000);
      })
      .catch((err) => setMssg({ ...mssg, mssg: err.message, error: true }));
  };

  const handleDownload = (type) => {
    const requestOptions = reqOptions("get", null, true);
    const api = `${HOST_URL()}estate_users/admin_list?estate_id=${getEstateID()}&limit=1000`;
    setDownLoading(true);
    fetch(api, requestOptions)
      .then((res) => res.json())
      .then((data) => {
        const myData = data?.results?.map((resident) => ({
          Name: `${resident?.user?.last_name} ${resident?.user?.first_name}`,
          ID: resident?.estate_user_id,
          Mobile: resident?.user?.mobile,
          Email: resident?.user?.email,
          "User Type": resident?.user_type,
          Status: resident?.status,
          "Added By": `${resident?.created_by?.user?.last_name} ${resident?.created_by?.user?.first_name}`,
          "User Category": resident?.user_category,
          Relationship: resident?.relationship,
        }));

        downloadData(myData, type, "Users");
      })
      .catch((err) => setMssg({ ...mssg, mssg: err.message, error: true }))
      .finally(() => setDownLoading(false));
  };

  return (
    <WithAuth>
      <main className="admin-residents-page">
        {mssg.mssg && <MssgContainer mssg={mssg} close={closeMssg} />}

        <header className="admin-residents-header">
          <div>
            <p className="admin-residents-kicker"><ResidentsIcon name="users" /> COMMUNITY DIRECTORY</p>
            <h1>Residents &amp; team</h1>
            <p>Manage residents, estate administrators and security personnel.</p>
          </div>
          <button type="button" className="admin-residents-add" onClick={() => setOpenModal(true)}><ResidentsIcon name="plus" /> Add User</button>
        </header>

        <section className="admin-residents-summary" aria-label="User summary">
          <div><span className="blue"><ResidentsIcon name="users" /></span><p><strong>{data?.count || 0}</strong>Total users</p></div>
          <div><span className="green"><ResidentsIcon name="check" /></span><p><strong>{data?.results?.filter((item) => item.status === "ACTIVE").length || 0}</strong>Active on this page</p></div>
          <div><span className="amber"><ResidentsIcon name="pause" /></span><p><strong>{data?.results?.filter((item) => item.status !== "ACTIVE").length || 0}</strong>Inactive on this page</p></div>
        </section>

      <section className="admin-residents-directory">
        <div className="admin-residents-directory-heading"><div><h2>User directory</h2><p>View contact information and manage account access.</p></div></div>
      <HandleSearchAndTab className="admin-residents-toolbar">
        <div className="tabs">
          <span
            className={`tab 1 ${checkActive(1)}`}
            onClick={() => filterResident(1, "ALL")}
          >
            <button>All</button>
          </span>

          <span
            className={`tab 2 ${checkActive(2)}`}
            onClick={() => filterResident(2, "ACTIVE")}
          >
            <button>Active</button>
          </span>
          <span
            className={`tab 3 ${checkActive(3)}`}
            onClick={() => filterResident(3, "INACTIVE")}
          >
            <button>Inactive</button>
          </span>
        </div>
        <div className="event-input">
          <div className="search_set">
            <ResidentsIcon name="search" />
            <input
              className="eventt"
              type="text"
              name="name"
              placeholder="Search by name or resident ID"
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          <button
            type="button"
            className="admin-residents-add admin-residents-add-toolbar"
            onClick={() => setOpenModal(true)}
          >
            <ResidentsIcon name="plus" /> Add User
          </button>

          <button
            className="admin-residents-export"
            disabled={downloading}
            onClick={() => handleDownload("xls")}
          >
            <ResidentsIcon name="download" /> Excel
          </button>
          <button
            className="admin-residents-export"
            disabled={downloading}
            onClick={() => handleDownload("csv")}
          >
            <ResidentsIcon name="download" /> CSV
          </button>
        </div>
      </HandleSearchAndTab>
      {bulkErrorText && <div className="admin-residents-error">{bulkErrorText}</div>}

      {loading ? (
        <div className="admin-residents-loading">
          <FontAwesomeIcon icon={faSpinner} size={"2xl"} />
          <p>Loading your community...</p>
        </div>
      ) : (
        <TableFrame>
          <div className="scrollable_table">
            <table>
              <thead>
                <tr>
                  <th>Residents</th>
                  <th>ID</th>
                  <th>Address</th>
                  <th>Contact</th>
                  <th>User Type</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>{residents && residents.length
                ? residents.map((resident, index) => (
                    <tr key={index}>
                      <td>
                        <div className="img-avatar">
                          <img src={getImage(resident.profile_image)} alt="" />
                          <div className="user-name"><strong>{resident.user.last_name} {resident.user.first_name}</strong><span>{resident.user.email}</span></div>
                        </div>
                      </td>
                      <td>{resident.estate_user_id}</td>
                      <td>{resident.estate.address}</td>

                      <td className="contact_data">
                        <div className="contact">
                          <a href={`tel:${resident.user.mobile}`} title={`Call ${resident.user.mobile}`}>
                            <img src={SVGs.Call} alt="" />
                          </a>
                          <a href={`mailto:${resident.user.email}`} title={`Email ${resident.user.email}`}>
                            <img src={SVGs.Email} alt="" />
                          </a>
                        </div>
                      </td>
                      <td><span className={`admin-residents-role ${resident.user_type?.toLowerCase()}`}>{titleCase(resident.user_type)}</span></td>
                      <td className="resume_data">
                        <div className="admin-residents-status-control">
                          <span className={resident.status === "INACTIVE" ? "inactive" : "active"}>{resident.status === "INACTIVE" ? "Inactive" : "Active"}</span>
                        <div className="checkbox_item citem_1">
                          <label className="checkbox_wrap">
                            <input
                              type="checkbox"
                              name="checkbox"
                              class="checkbox_inp"
                              checked={
                                resident.status === "INACTIVE" ? false : true
                              }
                              // onChange={() =>handleActivate(resident)}
                              onChange={() => {
                                setActionResident(resident);
                                setActionOpen(true);
                              }}
                            />
                            <span className="checkbox_mark"></span>
                          </label>
                        </div>
                        </div>
                      </td>
                    </tr>
                  ))
                : <tr><td colSpan="6"><div className="admin-residents-empty"><ResidentsIcon name="users" size={24} /><strong>No users found</strong><span>Try changing your search or selected status.</span></div></td></tr>}</tbody>
            </table>
          </div>
        </TableFrame>
      )}
      <div className="admin-residents-pagination">
        <Pagination
          totalCount={data?.count || 0}
          pageSize={50}
          onPageChange={(page) => setPage(page)}
        />
      </div>
      </section>
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        addUser={addUser}
        addMultipleUser={addMultipleUser}
      />
      <ConfirmAction
        open={actionOpen}
        onClose={() => {
          setActionResident(null);
          setActionOpen(false);
        }}
        resident={actionResident}
        handleActivate={handleActivate}
      />
      </main>
    </WithAuth>
  );
};

export default AdminResidents;

const Modal = ({ open, onClose, addUser, addMultipleUser }) => {
  const USER_TYPES = ["ADMIN", "RESIDENT", "SECURITY"];
  const USER_CATEGORIES = [
    "SECURITY",
    "HEAD_OF_SECURITY",
    "FINANCIAL_SECURITY",
    "PRESIDENT",
    "VICE_PRESIDENT",
  ];
  let default_value = {
    first_name: "",
    last_name: "",
    mobile: "",
    email: "",
    user_type: USER_TYPES[1],
    user_category: USER_CATEGORIES[0],
    is_child_security: false,
  };
  const [user, setUser] = useState(default_value);
  const [activeIndex, setActiveIndex] = useState(1);
  const [file, setFile] = useState("");
  const [isuploading, setIsUploading] = useState(false);
  const checkActive = (index) => (activeIndex === index ? "active" : "");
  const handleClick = (index) => setActiveIndex(index);

  if (!open) return null;
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUser({ ...user, [name]: value });
  };

  const handleChangeCheck = (e) => {
    const { name, checked } = e.target;
    setUser({ ...user, [name]: checked });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (user.user_type !== "SECURITY") delete user.user_category;
    addUser(user);
    setUser(default_value);
    onClose();
  };

  const handleUpload = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("csv_file", file, file.name);
    addMultipleUser(formData);
    onClose();
  };

  return (
    <div onClick={onClose} className="bills_on_me">
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        className="modalContainer"
      >
        <div className="new_estates_form fade-in-bck">
          <HandleSearchAndTab style={{ marginBottom: "0" }}>
            <div className="tabs" style={{ marginBottom: "0" }}>
              <span
                className={`tab ${checkActive(1)}`}
                onClick={() => handleClick(1)}
              >
                Single User
              </span>
              <span
                className={`tab ${checkActive(2)}`}
                onClick={() => handleClick(2)}
              >
                Bulk Upload
              </span>
            </div>
          </HandleSearchAndTab>
          <div className="panels">
            <div className={`panel ${checkActive(1)} fade-in-bck`}>
              <form className="" onSubmit={handleSubmit}>
                <div className="form-group">
                  <div className="create_est ">
                    <div className="form_txt">
                      <h3>Add User</h3>
                    </div>

                    <input
                      type="text"
                      value={user.first_name}
                      name="first_name"
                      placeholder="First Name"
                      onChange={handleChange}
                    />
                    <input
                      type="text"
                      value={user.last_name}
                      name="last_name"
                      placeholder="Last Name"
                      onChange={handleChange}
                    />
                    <input
                      type="text"
                      value={user.mobile}
                      name="mobile"
                      placeholder="Mobile phone"
                      onChange={handleChange}
                    />
                    <input
                      type="email"
                      value={user.email}
                      name="email"
                      placeholder="Email"
                      onChange={handleChange}
                    />
                    <p style={{ marginTop: 10 }}>User Type</p>
                    <select
                      onChange={handleChange}
                      name="user_type"
                      value={user.user_type}
                      className="form-control"
                      placeholder="User type"
                    >
                      {USER_TYPES.map((option) => (
                        <option value={option}>
                          {option.replace("_", " ")}
                        </option>
                      ))}
                    </select>
                    {user?.user_type === "SECURITY" && (
                      <>
                        <p style={{ marginTop: 10 }}>Security Category</p>
                        <select
                          onChange={handleChange}
                          name="user_category"
                          value={user.user_category}
                          placeholder="User Category"
                          className="form-control"
                          style={{ margin: "10px 0" }}
                        >
                          {USER_CATEGORIES.map((option) => (
                            <option value={option}>
                              {option.replace("_", " ")}
                            </option>
                          ))}
                        </select>
                      </>
                    )}

                    {user?.user_type === "SECURITY" && (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "30px",
                          marginTop: "20px",
                        }}
                      >
                        <input
                          type="checkbox"
                          name="is_child_security"
                          value={user.is_child_security}
                          checked={user.is_child_security}
                          onChange={handleChangeCheck}
                          style={{
                            width: "20px",
                            height: "20px",
                            marginTop: "0",
                          }}
                        />
                        <p style={{ whiteSpace: "nowrap", marginTop: "0" }}>
                          Sub-security
                        </p>
                      </div>
                    )}
                  </div>
                </div>
                <button className="btn btn-success btn-block">Add User</button>
              </form>
            </div>
            <div className={`panel ${checkActive(2)} fade-in-bck`}>
              <form onSubmit={handleUpload}>
                <div className="inputplabel">
                  <input
                    type="file"
                    id="imageChanger"
                    onChange={(e) => setFile(e.target.files[0])}
                    required
                  />
                  <button
                    className="important-btn"
                    style={{ margin: 0 }}
                    disabled={isuploading}
                  >
                    {isuploading ? "Uploading file" : "Add Users"}
                  </button>
                  <div className="dummy_holder" style={{ textAlign: "center" }}>
                    <label htmlFor="imageChanger">
                      <span>
                        <a
                          href={`${process.env.PUBLIC_URL}/bulk-residents.csv`}
                          download
                          style={{ color: "blue", fontWeight: "bolder" }}
                        >
                          Click Here
                        </a>{" "}
                        to download sample file.
                      </span>
                    </label>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        <img src={SVGs.close} alt="" onClick={onClose} />
      </div>
    </div>
  );
};

export const ConfirmAction = ({ open, onClose, resident, handleActivate }) => {
  if (!open) return null;

  const confirm = () => {
    handleActivate(resident);
    onClose();
  };

  return (
    <div onClick={onClose} className="bills_on_me">
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        className="modalContainer"
      >
        <div className="new_estates_form fade-in-bck">
          <h3>
            {resident.status === "INACTIVE" ? "Activate" : "Deactivate"}{" "}
            Resident
          </h3>
          <p>
            Are you sure you want to{" "}
            {resident.status === "INACTIVE" ? "activate" : "deactivate"} this
            resident?
          </p>
          <button onClick={confirm}>Yes, Please</button>
        </div>

        <img src={SVGs.close} alt="" onClick={onClose} />
      </div>
    </div>
  );
};

const HandleSearchAndTab = styled.section`
  .container {
    margin-bottom: 20px;
  }
  .normal_tab {
    background: transparent;
  }
  .event-input {
    max-width: 675px;
  }

  @media (min-width: 760px) {
    .search_set {
      margin-right: 10px;
    }
    display: flex;
    justify-content: space-between;
    .event-input {
      display: flex;
      justify-content: space-between;
      //   width: 57%;
      .select_me {
        margin-left: 10px;
        width: auto !important;
      }
      button {
        margin-top: 0;
        height: 45px;
      }
      .event-select {
        width: 20%;
      }
    }
  }
  @media (max-width: 540px) {
    .event-input {
      .event-select {
        display: none;
      }
    }
  }
  .tabs {
    margin: 0;
    margin-bottom: 30px;
    .tab {
      margin: 0;
      height: 45px;
      align-items: center;
      display: flex;
      justify-content: center;
      padding: 0;
      min-width: 100px;

      text-align: center;
      margin-right: 15px;
      border-bottom: 3px solid #c0c0c0;
      button {
        margin: 0;
        padding: 0 !important;
        padding: 10px;
        //styleName: Web/Small Copy;

        font-size: 16px;
        font-weight: 400;
        line-height: 17px;
        letter-spacing: 0em;
        text-align: left;
      }
    }
    .active {
      background: transparent;
      border-bottom: 3px solid #2d4bf3;
      color: #2d4bf3;
      button {
        color: #2d4bf3;
      }
    }
  }
  .normal_tab.add_tape {
    border-bottom: 2px solid yellow;
  }
`;
const TableFrame = styled.div`
  // .scrollable_table {
  //   font-family: "Satoshi";
  //   margin-left: 40px;
  //   font-style: normal;
  //   font-weight: 400;
  //   font-size: 16px;
  //   line-height: 121%;
  //   display: flex;
  //   align-items: center;
  //   /* Grey/2 */
  //   color: #545454;
  // }

  @media (max-width: 900px) {
    .scroll {
      min-width: 950px;
      width: 100%;
    }
  }

  .select_me {
    width: 150px;
    .select-btn {
      padding-left: 14px;
    }
  }

  .scrollable_table tr {
    margin-left: 20px;
  }

  .img-avatar img {
    width: 38px;
    height: 38px;
    object-fit: cover;
    border-radius: 50%;
  }
  .img-avatar {
    display: flex;
    align-items: center;
  }
  .user-name {
    margin-left: 10px;
    width: 134px;
    height: 23px;
    font-family: "DM Sans";
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 23px;
    display: flex;
    align-items: center;
    letter-spacing: -0.06em;

    /* Grey/1 */
    color: #111111;

    /* Inside auto layout */
    flex: none;
    order: 0;
    flex-grow: 0;
  }
  .team-members {
    // display: flex;
    // justify-content: space-between;
    margin-top: 40px;
  }

  .contact {
    margin: 5px;
    display: flex;
  }
  .contact a {
    margin: 8px;
    width: 30px;
    height: 30px;
  }
`;
